import { render, staticRenderFns } from "./CardClient.vue?vue&type=template&id=ac7170d4&scoped=true"
import script from "./CardClient.vue?vue&type=script&lang=js"
export * from "./CardClient.vue?vue&type=script&lang=js"
import style0 from "./CardClient.vue?vue&type=style&index=0&id=ac7170d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac7170d4",
  null
  
)

export default component.exports